import axios from 'axios';

const messageActions = (dispatch) => {
  return {
    loadMessageList: (
      type,
      id,
      channel,
      onlyUpdate = false,
      limit = 60,
      offset = 0
    ) => {
      onlyUpdate && dispatch({ type: 'MESSAGE_LIST_UPDATE' });
      offset === 0 && dispatch({ type: 'MESSAGE_LIST_LOAD' });
      offset > 0 && dispatch({ type: 'MESSAGE_LIST_UPDATE' });
      let newOffset = offset;
      const fetchPage = () => {
        const url =
          type === 'room'
            ? `/api/visitor/rooms/${id}/messages?channel=${channel}&limit=${limit}&offset=${offset}`
            : `/api/visitor/events/${id}/messages?channel=${channel}&limit=${limit}&offset=${offset}`;

        axios
          .get(url)
          .then((response) => {
            const total = response.data.total || 0;

            if (response.data.list) {
              newOffset += limit;
              dispatch({
                type: 'MESSAGE_LIST_SUCCESS',
                messageList: response.data.list,
                messageListTotal: total,
                messageListOffset: newOffset,
                messageListLimit: limit,
              });
            } else {
              dispatch({
                type: 'MESSAGE_LIST_ERROR',
                error: 'Wrong list format',
              });
            }
          })
          .catch((error) => {
            console.log(error);
            dispatch({
              type: 'MESSAGE_LIST_ERROR',
              error: 'Could not load messages',
            });
          });
      };

      fetchPage();
    },
    postMessage: (type, id, channel, data, cb) => {
      dispatch({ type: 'MESSAGE_POST_LOAD', post: data });
      const url =
        type === 'room'
          ? `/api/visitor/rooms/${id}/newchatmessage?channel=${channel}`
          : `/api/visitor/events/${id}/newchatmessage?channel=${channel}`;

      axios
        .post(url, data)
        .then((response) => {
          if (response.data) {
            cb && cb(response.data);
          } else {
            dispatch({ type: 'MESSAGE_POST_ERROR', error: 'Wrong format' });
          }
        })
        .catch(() => {
          dispatch({
            type: 'MESSAGE_POST_ERROR',
            error: 'Could not load messages',
          });
        });
    },
    moderateMessageToAsk: (messageId, cb) => {
      axios
        .put(`/api/visitor/messages/${messageId}/sendtoask`)
        .then((response) => {
          if (response.data) {
            cb && cb();
          }
        })
        .catch(() => {});
    },

    moderateMessage: (messageId, isMine, cb) => {
      dispatch({ type: 'MESSAGE_MODERATE', messageId: messageId });
      axios
        .put(
          `/api/visitor/messages/${messageId}/${
            isMine ? 'remove' : 'moderate'
          }`,
          {}
        )
        .then((response) => {
          if (response.data) {
            // Wait for socket
            //dispatch({type: 'MESSAGE_MODERATE_SUCCESS', post: response.data});
            cb && cb(response.data);
          } else {
            dispatch({ type: 'MESSAGE_POST_ERROR', error: 'Wrong format' });
          }
        })
        .catch(() => {
          dispatch({
            type: 'MESSAGE_POST_ERROR',
            error: 'Could not load messages',
          });
        });
    },
    bannUser: (messageId) => {
      dispatch({ type: 'MESSAGE_MODERATE', messageId: messageId });
      axios
        .put(`/api/visitor/messages/${messageId}`, {})
        .then((response) => {
          if (response.data) {
            // Wait for socket
            //dispatch({type: 'MESSAGE_MODERATE_SUCCESS', post: response.data});
          } else {
            dispatch({ type: 'MESSAGE_POST_ERROR', error: 'Wrong format' });
          }
        })
        .catch(() => {
          dispatch({
            type: 'MESSAGE_POST_ERROR',
            error: 'Could not load messages',
          });
        });
    },
  };
};
export default messageActions;
